import React from "react";
import ProductPageComponent from "../components/product/index";

const ProductPage = () => {
  return (
    <>
      <ProductPageComponent />
    </>
  );
};

export default ProductPage;
